import { Box } from '@stitch-fix/mode-react';
import ProductCard, { ProductCardProps } from '@stitch-fix/mode-react/ProductCard';

/**
 * ProductCard already instruments the newer sku events internally.
 */
type ProductCardWithEventsProps = Omit<ProductCardProps, 'categoryId' | 'skuId'> & {
  categoryId: string;
  skuId: string;
};
const ProductCardWithEvents = (props: ProductCardWithEventsProps) => {
  const productCardProps = {
    ...props
  } as ProductCardProps & Partial<Pick<ProductCardWithEventsProps, 'categoryId' | 'skuId'>>;

  // categoryId and skuId are accepted for backwards-compatible callers, but
  // are no longer needed because ProductCard reports the current events itself.
  delete productCardProps.categoryId;
  delete productCardProps.skuId;
  return <Box style={{
    overflow: 'hidden'
  }}>
      <ProductCard {...productCardProps} />
    </Box>;
};
export default ProductCardWithEvents;